import { Link } from 'react-router-dom';
import { HexLogo } from '@/components/feature/Navbar';

export default function Footer() {
  return (
    <footer className="bg-[#f8f7f2] border-t border-gray-200">
      <div className="max-w-6xl mx-auto px-8 md:px-14 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-5">
              <HexLogo dark />
            </div>
            <p
              className="text-gray-500 text-sm leading-relaxed max-w-xs"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Your trusted staffing partner.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="text-xs font-bold tracking-widest uppercase text-[#1a3a3a] mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Navigation
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'About Us', path: '/about' },
                { label: 'Services', path: '/services' },
                { label: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-500 text-sm hover:text-[#c8a84b] transition-colors duration-200"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-xs font-bold tracking-widest uppercase text-[#1a3a3a] mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Contact Us
            </h4>
            <ul className="space-y-4">
              {[
                { icon: 'ri-phone-line', value: '(480) 269-7513' },
                { icon: 'ri-mail-line', value: 'info@continuous-staffing.com' },
              ].map((item) => (
                <li key={item.value} className="flex items-center gap-3">
                  <i className={`${item.icon} text-[#c8a84b] text-sm`} />
                  <span
                    className="text-gray-500 text-sm"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {item.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-gray-400 text-xs"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            &copy; 2026 Continuous Staffing LLC. All rights reserved.
          </p>
          <p
            className="text-gray-400 text-xs"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Fast placements. Real results.
          </p>
        </div>
      </div>
    </footer>
  );
}
